import type { User } from '@/app/types/user';

/**
 * Who is shown the way into puzzle comments: the link on a puzzle, and the comment settings on the
 * account page. Admins only until the feature launches, at which point this returns true.
 *
 * It decides what is offered, not what is allowed: the comments API answers anyone who asks.
 */
export const commentsOfferedTo = (user: User | null): boolean => user?.role === 'admin';
